import React from 'react';
import Select from 'react-select';

export default function VersionSelect({version, versions, setVersion}) {
    if (versions.length) {
        const selectVersions = versions.map(version => ({value: version.VersionDescription, label: version.VersionDescription, status: version.Status}))
        const selectStyles = {
            option: (styles, {data, isFocused, isSelected}) => {
                let color;
                switch(data.status) {
                    case "Completed":
                        color = '#48BB78';
                        break;
                    case "Submitted":
                        color = '#ED8936';
                        break;
                    case "Query Submit":
                        color = '#ECC94B';
                        break;
                    case "Failed":
                        color = "#DC2626";
                        break;
                    default:
                        color = '#1F2937';
                        break;
                }

                return {
                    ...styles,
                    color,
                }
            },
            container: (styles, {isFocused, isSelected}) => ({...styles, borderColor: isFocused ? '#38b2ac' : isSelected ? '#38b2ac' : '#e2e8f0' })
        }

        const theme = theme => ({
            ...theme,
            colors: {
              ...theme.colors,
              primary: '#9575CD',
              primary25: '#faf5ff',
              primary50: '#d6bcfa',
              neutral20: '#e2e8f0',
              neutral30: '#cbd5e0'
            }})

        return (
            <div className="p-5 mb-10 ml-5 bg-white shadow">
                <h2 className="bg-purple-l border-b border-gray-200 px-6 py-2 text-white font-bold tracking-wider uppercase text-md">Version Select</h2>
                <div className="w-64 px-6 mt-5">
                    <label className="block tracking-wide text-gray-600 text-xs font-bold mb-2" htmlFor="versionSelect">
                        Select a version
                    </label>
                    <Select placeholder={version || "Version..."} options={selectVersions} id="versionSelect" onChange={(v) => setVersion(v.value)} styles={selectStyles} theme={theme} />
                </div>
            </div>
        )
    } else {
        return <div>Loading...</div>
    }
}
